import { render, staticRenderFns } from "./yiSkin.vue?vue&type=template&id=4ca7fb96&scoped=true&"
import script from "./yiSkin.vue?vue&type=script&lang=js&"
export * from "./yiSkin.vue?vue&type=script&lang=js&"
import style0 from "./yiSkin.vue?vue&type=style&index=0&id=4ca7fb96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca7fb96",
  null
  
)

export default component.exports